import {useState, useCallback} from 'react'
import {ConfirmationDialog} from "./ConfirmationDialog";

const _defaultOpts = {
    title: "Title",
    description: "Description",
    confirmationText: 'Ok',
    cancellationText: 'Cancel',
    disableClose: false,
    showDoNotAskMeLater: false,
    defaultDoNotAskMeLater: false,
    doNotAskMeLaterMessage: "Do not ask me later",
    onConfirm: () => console.warn('[ConfirmDialog] onConfirm in not defined')
};

const useConfirmationDialog = () => {
    const [isOpen, setOpen] = useState(false);
    const [options, setOptions] = useState(_defaultOpts);

    const onClose = useCallback(() => {
        setOpen(false);
    }, []);

    const askConfirmation = useCallback((opts) => {
        setOptions(Object.assign({}, _defaultOpts, opts));
        setOpen(true);
    }, []);

    return {
        isOpen,
        options,
        onClose,
        askConfirmation
    }
};

export {useConfirmationDialog, ConfirmationDialog}